// LocalStorage keys
export const STORAGE_PREFIX = 'msd_' // multi-screen-display

export const STORAGE_KEYS = {
  // Layout storage
  LAYOUTS: `${STORAGE_PREFIX}layouts`,
  ACTIVE_LAYOUT: `${STORAGE_PREFIX}active_layout`,

  // Display state
  DISPLAY_STATE: `${STORAGE_PREFIX}display_state`,
  STATE_SNAPSHOT: `${STORAGE_PREFIX}state_snapshot`,
  FULLSCREEN_STATE: `${STORAGE_PREFIX}fullscreen_state`,

  // Sync fallback
  SYNC_MESSAGES: `${STORAGE_PREFIX}sync_messages`,
  LAST_SYNC_ID: `${STORAGE_PREFIX}last_sync_id`,

  // Settings
  SETTINGS: `${STORAGE_PREFIX}settings`,
  THEME: `${STORAGE_PREFIX}theme`,

  // Window management
  CONTROL_WINDOW_ID: `${STORAGE_PREFIX}control_window_id`,
  DISPLAY_WINDOWS: `${STORAGE_PREFIX}display_windows`,
} as const

// IndexedDB configuration
export const IDB_NAME = 'MultiScreenDisplayDB'
export const IDB_VERSION = 1

export const IDB_STORES = {
  LAYOUTS: 'layouts',
  CONTENT: 'content',
  SETTINGS: 'settings',
  STATE: 'state',
} as const
